import { render, staticRenderFns } from "./VpnKeyOutlined.vue?vue&type=template&id=455c4df0&"
import script from "./VpnKeyOutlined.vue?vue&type=script&lang=js&"
export * from "./VpnKeyOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports